import { FC, Suspense, lazy } from 'react'
import { Outlet, Routes, Route } from 'react-router-dom'

import SuspenseFallback from '../components/SuspenseFallback'

import routePaths from './route-paths'

type ContextType = { tableId?: number }

const AppLayout: FC<ContextType> = props => (
  <Suspense fallback={<SuspenseFallback withPadding />}>
    <Outlet />
  </Suspense>
)

const ProjectContainer = lazy(() =>
  import('../features/projects').then(module => ({ default: module.ProjectContainer }))
)

export const Router: FC<ContextType> = props => (
  <Suspense fallback={<SuspenseFallback withPadding />}>
    <Routes>
      <Route element={<AppLayout {...props} />}>
        <Route
          path={`${routePaths.project}/:uuid`}
          element={<ProjectContainer tableId={props.tableId} isEditable={true} />}
        />
        <Route
          path={`${routePaths.project}/:uuid/:viewId`}
          element={<ProjectContainer tableId={props.tableId} isEditable={true} />}
        />
      </Route>
    </Routes>
  </Suspense>
)

export default Router
